import React from 'react';
export function App() {
  return <div className="w-full min-h-screen bg-[#f8f5f0] flex flex-col items-center justify-center p-4" data-id="element-0">
      <div className="max-w-md w-full bg-white rounded-2xl shadow-sm p-8 md:p-10 text-center" data-id="element-1">
        <h1 className="text-2xl md:text-3xl font-medium text-[#4d7c5f] mb-6" data-id="element-2">
          Thanks for signing up!
        </h1>
        <p className="text-gray-700 text-lg mb-8" data-id="element-3">
          We'll be in touch soon. Check your inbox{' '}
          <span className="text-[#4d7c5f]" data-id="element-4">🌿</span>
        </p>
        <a href="https://como.care" className="inline-block px-6 py-3 bg-[#4d7c5f] hover:bg-[#3d6a4f] text-white rounded-lg transition-colors duration-200" data-id="element-5">
          Return to como.care
        </a>
      </div>
      <div className="mt-8 text-sm text-gray-500" data-id="element-6">
        <span className="text-[#4d7c5f]" data-id="element-7">COMO</span> ©{' '}
        {new Date().getFullYear()}
      </div>
    </div>;
}